<template>
  <ARow v-if="value">
    呼叫中心 {{ isAudio }} 屏幕分享 {{ isShare }}
    <video ref="video" autoplay playsinline :style="getStyle"></video>
    {{ displayTime }}
    <AButton @click="$emit('accept')" v-if="showAccept">同意</AButton>
    <AButton @click="hangup">挂断</AButton>
    <AButton @click="refuse" v-if="showRefuse">拒绝</AButton>
    <AButton @click="instance.openMic">开启MIC</AButton>
    <AButton @click="instance.closeMic">关闭MIC</AButton>
    <AButton @click="instance.openCamera">开启摄像头</AButton>
    <AButton @click="instance.closeCamera">关闭摄像头</AButton>
    <AButton @click="doshare">开启屏幕分享</AButton>
    <AButton @click="closeshare">关闭屏幕分享</AButton>
    <!-- <AButton @click="instance.outMeeting">退出此次会议</AButton> -->
    <div slot="footer"></div>
  </ARow>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "CallBox",
  props: ["value", "isCaller", "meetingId", "calling", "instance", "isAudio", "isShare"],
  data() {
    return {
      timer: null,
      time: 0
    };
  },
  computed: {
    displayTime() {
      return dayjs(this.time).format("mm:ss");
    },
    showAccept() {
      return !this.calling;
    },
    showHangup() {
      return this.calling;
    },
    showRefuse() {
      return !this.calling;
    },
    getStyle() {
      if (this.isAudio) {
        return {
          width: "0",
          height: "0"
        };
      } else {
        return {
          width: "300px",
          height: "300px"
        };
      }
    }
  },
  watch: {
    calling(val) {
      this.time = 0;
      if (val) {
        this.$nextTick(() => {
          this.initVideo();
        });
      } else {
        this.destroyVideo();
      }
    },
    value(val) {
      if (val) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.time = this.time + 1000;
        }, 1000);
      } else {
        clearInterval(this.timer);
      }
    }
  },
  methods: {
    hangup() {
      if (this.isAudio) {
        this.$emit("hangup", "hangupAudio");
      } else if (this.isShare) {
        this.$emit("hangup", "hangupShare");
      } else {
        this.$emit("hangup", "hangupVideo");
      }
    },
    refuse() {
      if (this.isAudio) {
        this.$emit("refuse", "refuseAudio");
      } else if (this.isShare) {
        this.$emit("refuse", "refuseShare");
      } else {
        this.$emit("refuse", "refuseVideo");
      }
    },
    initVideo() {
      if (this.isAudio) {
        const aab = this.instance.initAudioTag(
          this.$refs.video,
          this.meetingId
        );
      } else if (this.isShare){
        const aab = this.instance.initShareTag(
          this.$refs.video,
          this.meetingId,
          this.isCaller
        );
      } else {
        const aab = this.instance.initVideoTag(
          this.$refs.video,
          this.meetingId
        );
      }
    },
    doshare() { // 开启分享
      this.instance.doShareCall(this.meetingId, true);
    },
    closeshare() { // 停止分享
      this.instance.closeShare()
    },
    destroyVideo() {}
  }
};
</script>

<style scoped></style>
